/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionClientsGet } from "../funcs/organizationRemoteSessionClientsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteSessionClient } from "../models/components/remotesessionclient.js";
import {
  GetOrganizationRemoteSessionClientRequest,
  GetOrganizationRemoteSessionClientSecurity,
} from "../models/operations/getorganizationremotesessionclient.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationRemoteSessionClientQueryData = RemoteSessionClient;

export function prefetchOrganizationRemoteSessionClient(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationRemoteSessionClientRequest,
  security?: GetOrganizationRemoteSessionClientSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionClientQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationRemoteSessionClientQuery(
  client$: GramCore,
  request: GetOrganizationRemoteSessionClientRequest,
  security?: GetOrganizationRemoteSessionClientSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionClientQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionClient({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function organizationRemoteSessionClientQueryFn(
      ctx,
    ): Promise<OrganizationRemoteSessionClientQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationRemoteSessionClientsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOrganizationRemoteSessionClient(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionClients",
    "get",
    parameters,
  ];
}
